import $ from 'jquery';
import 'jquery-sticky';

// jQuery plugin for segment sticky menu from http://stickyjs.com
Drupal.behaviors.troaxSegmentStickyMenu = {
  attach() {
    $('.sub-menu-segment')
      .once('troaxSegmentStickyMenu')
      .each((index, element) => this.segmentStickyMenu(element));
  },

  segmentStickyMenu(element) {
    const mq = window.matchMedia('(min-width: 1024px');
    if (mq.matches) {
      $(element).sticky({
        topSpacing: 0,
        getWidthFrom: '.sub-menu-segment',
        responsiveWidth: true,
        zIndex: 1,
      });
    }

    $('.menu-shortcuts li').on('click', function () { // eslint-disable-line
      /* remove classname 'active' from all li who already has classname
      'active' & add to the link that has click */
      $(this).addClass('active').siblings('li').removeClass('active');
    });

    // Resize is not working yet

    // $(window).resize(() => {
    //   $(element).on('sticky-update', () => {
    //     console.log($(element));
    //     sticky('update');
    //   });
    //   console.log('updated');
    // });
  },
};
